import { render, staticRenderFns } from "./RateApiRouteControl.vue?vue&type=template&id=48ef53c3&scoped=true"
import script from "./RateApiRouteControl.vue?vue&type=script&lang=js"
export * from "./RateApiRouteControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ef53c3",
  null
  
)

export default component.exports